import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.auth.login');
import { OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-auth-login',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.auth.login/view.scss */
:host {
  display: block;
  height: 100%;
}

@keyframes float-slow {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(30px, -30px);
  }
}
@keyframes float-delay {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(-20px, 20px);
  }
}
@keyframes float-mid {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(15px, 15px);
  }
}
.animate-float-slow {
  animation: float-slow 8s ease-in-out infinite;
}

.animate-float-delay {
  animation: float-delay 10s ease-in-out infinite;
}

.animate-float-mid {
  animation: float-mid 6s ease-in-out infinite;
}

@keyframes logo-glow {
  0%, 100% {
    filter: drop-shadow(0 0 8px rgba(246, 146, 50, 0));
  }
  50% {
    filter: drop-shadow(0 0 20px rgba(246, 146, 50, 0.3));
  }
}
.animate-logo-glow {
  animation: logo-glow 4s ease-in-out infinite;
}

@keyframes hero-fade {
  0% {
    opacity: 0;
    transform: translateY(-12px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-hero-fade {
  animation: hero-fade 0.6s ease-out;
}

@keyframes feature-fade {
  0% {
    opacity: 0;
    transform: translateY(16px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-feature-1 {
  animation: feature-fade 0.4s ease-out 0.2s both;
}

.animate-feature-2 {
  animation: feature-fade 0.4s ease-out 0.3s both;
}

.animate-feature-3 {
  animation: feature-fade 0.4s ease-out 0.4s both;
}

.animate-feature-4 {
  animation: feature-fade 0.4s ease-out 0.5s both;
}

.animate-feature-5 {
  animation: feature-fade 0.4s ease-out 0.6s both;
}

.animate-feature-6 {
  animation: feature-fade 0.4s ease-out 0.7s both;
}`],
})
export class PortalAuthLoginComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;

    public form = {
        email: '',
        password: ''
    };

    public loading = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(false, '/home');
        await this.service.render();
    }

    private showModal(message): Promise<boolean> {
        return this.modalMessage.open({ message });
    }

    public async login() {
        if (this.loading) return;

        if (!this.form.email?.trim()) {
            await this.showModal('이메일을 입력해주세요');
            return;
        }

        if (!this.form.password) {
            await this.showModal('비밀번호를 입력해주세요');
            return;
        }

        this.loading = true;

        const payload: any = {
            email: this.form.email.trim(),
            password: this.form.password
        };

        try {
            const { code } = await wiz.call(
                'login',
                payload,
                { credentials: 'include' }
            );

            if (code === 200) {
                location.href = '/home';
            } else {
                await this.showModal('이메일 또는 비밀번호를 확인해주세요');
            }
        } catch (e) {
            await this.showModal('이메일 또는 비밀번호를 확인해주세요');
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }
}

export default PortalAuthLoginComponent;